/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuestAuthenticationEnum } from "../../environments/types/GuestAuthenticationEnum";
import { InternalSpaceConfigBase } from "./InternalSpaceConfigBase";
export const SpaceConfig = core.serialization
    .object({
    name: core.serialization.string().optional(),
    displayOrder: core.serialization.number().optional(),
    guestAuthentication: core.serialization.list(GuestAuthenticationEnum).optional(),
})
    .extend(InternalSpaceConfigBase);
